export default __webpack_public_path__ + "static/media/building1.57fd1c62.webp";